import { Controller } from "stimulus";
import { placePopover, visibleViewport } from "../../training_grooming_calendar/popover";
import { openDisclosure, closeOverlay, isOpenFrom } from "../../training_grooming_calendar/overlay";
import { submitBlock, deleteBlock } from "../../training_grooming_calendar/block_submit";

export default class extends Controller {
  static targets = ["container"];

  toggle(event) {
    event.preventDefault();
    event.stopPropagation();
    const anchor = event.currentTarget;
    const popover = this.containerTarget.querySelector(`.dc-m-popover[data-block-id="${anchor.dataset.blockId}"]`);
    if (!popover) return;
    if (isOpenFrom(popover, anchor)) {
      closeOverlay();
      return;
    }
    const frame = this.containerTarget.querySelector(".tg-frame");
    if (popover.parentElement !== frame) frame.appendChild(popover);
    const sheet = frame.classList.contains("tg-mobile");
    openDisclosure({ element: popover, trigger: anchor, root: this.element, sheet, openClass: "open" });
    if (!sheet) this.position(popover, anchor, event.detail > 0 ? { x: event.clientX, y: event.clientY } : null);
    const close = popover.querySelector(".dc-m-pop-close");
    if (close) close.focus({ preventScroll: true });
  }

  closeBlockPopover() {
    closeOverlay();
  }

  remove(event) {
    if (!(event.detail && event.detail[0])) return;
    const button = event.currentTarget;
    const token = document.querySelector('meta[name="csrf-token"]');
    submitBlock({
      button,
      send: () => deleteBlock({ url: button.dataset.url, token: token ? token.content : "" }),
      notify: window.notyf,
      done: () => {
        closeOverlay({ restoreFocus: false });
        this.element.dispatchEvent(new CustomEvent("training-grooming:reload"));
      },
    });
  }

  position(popover, anchor, point) {
    const { left, top } = placePopover({
      anchor: anchor.getBoundingClientRect(),
      container: this.containerTarget.getBoundingClientRect(),
      viewport: visibleViewport(),
      width: popover.offsetWidth,
      height: popover.offsetHeight,
      point,
    });
    popover.style.left = `${left}px`;
    popover.style.top = `${top}px`;
  }
}
